
















































































import { onMounted, ref } from "@vue/composition-api";
import Vue from "vue";
import PassivePopup from "../PassivePopup.vue";
import SensitivityLabel from "../SensitivityLabel.vue";
export default Vue.extend({
  components: { SensitivityLabel, PassivePopup },
  props: {
    value: {
      type: Number,
      default: 3,
    },
    min_level: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const show_popup = ref(false);
    const sensitivities = [[0, 1, 2, 3], [1, 2, 3], [2, 3], [3]].slice(
      (props.min_level as number) || 0
    );
    const selected_levels = ref([1, 2, 3]);
    onMounted(() => {
      selected_levels.value = sensitivities.find(
        ([first_level]) => first_level === (props.value as number)
      ) || [3];
    });

    const select_level = (group: number[]) => {
      selected_levels.value = group;
      emit("input", selected_levels.value[0]);
      show_popup.value = false;
    };

    return {
      selected_levels,
      show_popup,
      sensitivities,
      select_level,
    };
  },
});
